export const GjensidgeTermsContent: React.FC = () => {
  return (
    <div className="flex flex-col gap-6">
      <h4>
        Gyventojų turto draudimo specialiosios sąlygos UAB „Viena sąskaita“
        klientams
      </h4>
      <p>
        UAB „Viena sąskaita“ ir ADB Gjensidige pasirašytu susitarimu prie
        bendradarbiavimo sutarties apdraudė būstų savininkus Gyventojų turto
        draudimu pagal žemiau nurodytas sąlygas
      </p>
      <h4>1. Sąvokos</h4>
      <ul className="ml-2 list-none">
        <li>
          1.1. <strong>Draudikas</strong> - ADB Gjensidige
        </li>
        <li>
          1.2. <strong>Draudėjas</strong> - UAB Viena sąskaita
        </li>
        <li>
          1.3. <strong>Apdraustasis</strong> - turto savininkas/naudos gavėjas,
          t.y. asmuo, apdraudęs savo nuosavybės teise valdomą turtą
          (būstą/daiktus)
        </li>
        <li>
          1.4. <strong>Naudos gavėjas</strong> - Asmuo, turintis teisę gauti
          draudimo išmoką (pvz., naudos gavėju gali būti bankas, kuriam įkeistas
          apdraudžiamas turtas, lizingo davėjas, iš kurio / per kurį įsigijimas
          turas.
        </li>
        <li>
          1.5. <strong>Šeimos nariai</strong> - tai sutuoktinis ir/arba nuolatos
          kartu su Jumis gyvenantys ir bendro ūkio siejami nesusituokę asmenys,
          Jūsų vaikai (įvaikiai) ir jų sutuoktiniai, vaikaičiai, tėvai
          (įtėviai), seneliai, broliai, seserys.
        </li>
        <li>
          1.6. <strong>Vertybės</strong> - tai:
          <ul className="ml-2 list-none">
            <li>1.6.1. Grynieji pinigai, esantys ne banko sąskaitoje;</li>
            <li>
              1.6.2. Papuošalai, juvelyriniai dirbiniai, taurieji metalai
              (auksas, platina, sidabras ir pan.), brangakmeniai, perlai, taip
              pat bet kokie dirbiniai, kurių sudėtyje yra tauriųjų metalų,
              brangakmenių, perlų, pašto ženklai, kolekcijos ir jų dalys, ginklų
              kolekcijos, monetos, medaliai;
            </li>
            <li>
              1.6.3. Laikrodžiai, kurių vieneto vertė yra didesnė kaip 1.000 EUR
            </li>
            <li>
              1.6.4. Kailiai, kailių bei odos gaminiai, meno kūriniai ir
              dirbiniai (paveikslai, piešiniai, retos knygos ir rankraščiai,
              grafikos darbai, skulptūros, rankų darbo kilimai, gobelenai ir
              pan.), vazos, indų servizai ir (arba) interjero puošybos
              elementai, kurių vieneto vertė yra didesnė kaip 1.500 EUR;
            </li>
            <li>
              1.6.5. Dokumentai, kuriuos galima atkurti remiantis nepriklausomų
              registrų ar kitų oficialių šaltinių duomenimis, įskaitant banko
              korteles. Nuostoliu bus laikoma tik šių dokumentų ar kortelių
              atkūrimo išlaidos;
            </li>
            <li>
              1.6.6. Antikvariniai daiktai. Antikvariniais daiktais mes laikome
              bet kokius daiktus, išskyrus meno kūrinius ir kolekcinius daiktus,
              kurie yra senesni kaip 50 metų;
            </li>
            <li>
              1.6.7. Muzikos instrumentai, kurių vieneto vertė didesnė kaip
              5.000 EUR.
            </li>
          </ul>
        </li>
        <li>
          1.7. <strong>Būsto nuomos išlaidos</strong> - tai išlaidos už laikiną
          gyvenamosios vietos nuomą, daiktų perkraustymą, laikiną išlikusio
          turto saugojimą, jeigu pastatas, butas dėl draudžiamojo įvykio yra
          sunaikintas ar prarastas ir/ar netinkamas gyventi.
        </li>
        <li>
          1.8.{" "}
          <strong>
            Papildomos išlaidos draudimo vietai sutvarkyti po draudžiamojo
            įvykio
          </strong>{" "}
          - tai išlaidos, tiesiogiai susijusios su apdrausto pastato, buto
          draudžiamojo įvykio padarinių likvidavimu (išlikusių pastato dalių
          nuvalymas arba nugriovimas, šiukšlių išvežimas, teritorijos
          sutvarkymas, vandens išsiurbimas, drėgmės ar kvapo panaikinimas,
          išlaidos specialiems rūbams ar inventoriui, skirtos likviduoti
          nuostolius).
        </li>
        <li>
          1.9. <strong>Tretieji asmenys</strong> - visi asmenys, išskyrus:
          <ul className="ml-2 list-none">
            <li>1.9.1. Jus, Jūsų šeimos narius, naudos gavėjus;</li>
            <li>
              1.9.2. Turto bendrasavininkus, nuomininkus, asmenis, kuriems Jūs
              pavedėte ar kitaip teisėtai patikėjote saugoti apdraustą turtą,
              rūpintis juo;
            </li>
            <li>1.9.3. Kitus įstatymų nustatyta tvarka įgaliotus atstovus;</li>
            <li>
              1.9.4. Asmenis, kartu su Jumis disponuojančius apdraustu turtu,
              dirbančius Jūsų patalpose;
            </li>
            <li>
              1.9.5. Asmenis, teisėtai esančius Jūsų ir/ar Jūsų valdomose /
              naudojamose patalpose.
            </li>
          </ul>
        </li>
        <li>
          1.10.{" "}
          <strong>
            Nukentėjęs tretysis asmuo civilinės atsakomybės draudimo atveju
          </strong>{" "}
          - asmuo, kuriam Jūs ar Jūsų šeimos nariai padarėte žalos ir kuris
          įstatymų nurodytomis sąlygomis įgyja teisę į draudimo išmoką.
        </li>
        <li>
          1.11. <strong>Nuolat gyvenamas pastatas, butas</strong> - pastatas
          arba jo dalis, butas, kuriame Jūs ir/ar jūsų šeimos nariai nuolatos
          gyvenate ne mažiau kaip 8 mėnesius per metus, nepalikdami šio būsto be
          priežiūros ilgiau kaip 28 dienas.
        </li>
        <li>
          1.12. <strong>Sukčiavimas</strong> - tai apgaulės panaudojimas
          svetimam turtui užvaldyti arba teisei į turtą įgyti, kai apgaulė
          panaudojama turint tikslą suklaidinti turto savininką ar valdytoją
          arba asmenį, kurio žinioje yra turtas, o pastarieji dėl suklydimo
          apgaulės įtakoje savanoriškai patys perleidžia turtą ar teisę į turtą
          kaltininkui, manydami, kad šis turi teisę jį gauti.
        </li>
        <li>
          1.13. <strong>Turto prievartavimas</strong> - tai atviras ar
          užmaskuotas paslaugų siūlymu ar kitokia forma pridengtas neteisėtas
          reikalavimas perduoti turtą, teisę į turtą arba padaryti kitus
          veiksmus ar nuo jų susilaikyti, tiesiogiai arba užuominomis grasinant
          panaudoti fizinį smurtą prieš nukentėjusįjį ar jo artimuosius, ar
          kitaip šantažuojant arba panaudojant kitokią prievartą.
        </li>
        <li>
          1.14. <strong>Turto pasisavinimas</strong> - tai neteisėtas patikėto
          ar apdraustojo žinioje esančio svetimo turto užvaldymas (bent trumpam
          laiko tarpui) turint realią galimybę juo naudotis ar disponuoti.
        </li>
        <li>
          1.15. <strong>Turto iššvaistymas</strong> - tai asmeniui patikėto ar
          jo žinioje esančio turto neteisėtas perleidimas (pardavimas,
          dovanojimas ar pan.). tretiesiems asmenims.
        </li>
        <li>
          1.16. <strong>Plėšimas</strong> - turto pagrobimas, atėmimas Jūsų ar
          Jūsų šeimos nario atžvilgiu panaudojant fizinę jėgą ar fizinį smurtą
          arba grasinant jį panaudoti, arba kitaip atėmus galimybę Jums ar Jūsų
          šeimos nariui priešintis, arba pasinaudojant Jūsų ar Jūsų šeimos narių
          bejėgiška būkle.
        </li>
        <li>
          1.17. <strong>Balkonas (lodžija)</strong> - pastato fasado dalis su
          išsikišusia iš fasado arba įtraukta į pastato vidų aikštele. Balkonai
          ir lodžijos gali būti atviri arba uždari (įstiklinti). Balkonas ir
          (ar) lodžija, priklausantys apdraustam pastatui ar patalpai, yra
          laikomi apdraustais kartu su šiuo pastatu ar patalpa
        </li>
        <li>
          1.18. <strong>Didelis neatsargumas</strong> - tai asmens elgesys,
          pasireiškiantis veiksmais, kurių asmuo, laikydamasis bent minimalių
          atsargumo ir dėmesingumo reikalavimų, nebūtų padaręs, taip pat kitos
          aplinkybės, patvirtinančios asmens didelį neatsargumą (pvz., asmens
          girtumas, apsvaigimas nuo narkotinių, toksinių ar psichotropinių
          medžiagų, rūkymas lovoje, neturėjimas teisės dirbti su atitinkamais
          įrenginiais ar mechanizmais, neturėjimas teisės vykdyti atitinkamų
          statybos, remonto ar rekonstrukcijos darbų).
        </li>
        <li>
          1.19. <strong>Nedraudžiamasis įvykis</strong> - draudimo sutartyje
          ir/ar įstatymuose nurodytas įvykis, kuriam įvykus draudikas nemoka
          draudimo išmokos.
        </li>
        <li>
          1.20. <strong>Draudimo liudijimas</strong> - draudėjui išduodamas
          dokumentas, patvirtinantis draudimo sutarties sudarymą;
        </li>
        <li>
          1.21. <strong>Sertifikatas</strong> - Apdraustajam išduodamas
          dokumentas patvirtinantis draudimo apsaugą.
        </li>
        <li>
          1.22.{" "}
          <a
            href="https://www.gjensidige.lt/-/media/lt/valid-rules/2018/gt-papildomos/060-gyventoju-turto-draudimo-taisykles_lt_2018-04.pdf"
            target="_blank"
          >
            <strong>Gyventojų turto draudimo taisyklės Nr. 060</strong>
          </a>{" "}
          (toliau Taisyklės) – dokumentas, kuriame nustatytos standartinės
          asmens draudimo sutarties sąlygos ir kuris skelbiamas draudiko
          internetiniame puslapyje{" "}
          <a href="http://www.gjensidige.lt">www.gjensidige.lt</a>. Esant
          prieštaravimams ar neatitikimams tarp šių Gyventojų turto draudimo
          specialiųjų sąlygų ir Taisyklių ar Taisyklių priedų sąlygų, pirmenybė
          teikiama šioms Gyventojų turto draudimo specialioms sąlygoms.
        </li>
      </ul>
      <h4>2. Šalių teisės ir pareigos:</h4>
      <ul className="ml-2 list-none">
        <li>
          2.1. Apdraustojo teisės ir pareigos:
          <ul className="ml-2 list-none">
            <li>
              2.1.1. Įvykus įvykiui, kuris gali būti laikomas draudžiamuoju
              įvykių, neatidėliodamas, bet ne vėliau kaip 3 darbo dienas
              apdraustasis privalo pranešti apie įvykį draudikui;
            </li>
            <li>
              2.1.2. susipažinti su mūsų tvarkomais savo asmens duomenimis ir
              reikalauti ištaisyti neišsamius, neteisingus, netikslius savo
              asmens duomenis ar pareikšti nesutikimą, kad būtų tvarkomi Jūsų
              asmens duomenys.
            </li>
          </ul>
        </li>
        <li>
          2.2. Kreipdamasis dėl draudimo išmokos į Draudiką, pateikti visų
          draudžiamąjį įvykį patvirtinančių dokumentų originalus arba jų
          patvirtintas kopijas ir suteikti visą Draudiko reikalaujamą
          informaciją, susietą su draudžiamuoju įvykiu;
          <ul className="ml-2 list-none">
            <li>
              2.2.1. įstatymuose numatyta tvarka gauti informaciją apie
              draudžiamojo įvykio tyrimo eigą;
            </li>
            <li>
              2.2.2. Leisti draudikui susipažinti su visa dokumentacija ir
              teisinių institucijų turima informacija;
            </li>
          </ul>
        </li>
        <li>
          2.3. <strong>Draudikas turi teisę:</strong>
          <ul className="ml-2 list-none">
            <li>
              2.3.1. Kreiptis į VĮ „Registrų centas“ dėl informacijos apie
              draudžiamus pastatus, butus gavimo;
            </li>
            <li>
              2.3.2. Teikti rekomendacijas apdraustajam nuostolių sumažinimui;
            </li>
            <li>
              2.3.3. Savo nuožiūra kartu su Draudėju ar savarankiškai tirti
              įvykio aplinkybes.
            </li>
            <li>
              2.3.4. Jei jūs nevykdote šiose taisyklėse ir draudimo sutartyje
              nustatytų pareigų, mes turime teisę atsisakyti išmokėti draudimo
              išmoką arba ją sumažinti, atsižvelgdami į tai, ar Jūs savo
              pareigos neįvykdėte tyčia ar dėl neatsargumo;
            </li>
            <li>
              2.3.5. Reikalauti papildomos informacijos iš policijos,
              prokuratūros, teismo, priešgaisrinės tarnybos ir kitų įstaigų.
            </li>
          </ul>
        </li>
        <li>
          2.4. Bet kokie Draudiko veiksmai, išvardinti šių taisyklių punktuose
          2.2.1.-2.2.5 nereiškia, kad Draudikas pripažįsta savo atsakomybę dėl
          draudžiamojo įvykio arba ją neigia.
        </li>
      </ul>
      <h4>3. Draudimo sąlygos</h4>
      <ul className="ml-2 list-none">
        <li>
          3.1. Draudimo objektas – turtiniai interesai, susiję su apdraustu
          turtu bei Apdraustojo kaip apdrausto turto savininko (valdytojo)
          civiline atsakomybe.
        </li>
        <li>
          3.2. Draudžiamas turtas:
          <ul className="ml-2 list-none">
            <li>
              3.2.1. Pastatai - stogu apdengtas, tvirtai su žeme sujungtas
              statinys (taip pat statinio priestatai, antstatai ir jų dalys),
              kuriame yra vienas ar daugiau kambarių ar kitų patalpų naudojamų
              žmonėms gyventi, ilsėtis (pvz. gyvenamas namas, gyvenamo namo
              dalis, kotedžas).
            </li>
            <li>
              3.2.2. Butas - gyvenamoji patalpa atskirta nuo bendro naudojimo
              patalpų, kitų butų ar negyvenamųjų patalpų ir užregistruota
              nekilnojamo turto registre kaip atskiras nekilnojamojo turto
              objektas (pvz. butas, poilsio patalpa, apartamentai ir pan.)
            </li>
            <li>
              3.2.3. Namų turtas - namų apstatymui, buitiniam naudojimui bei
              vartojimui skirti kilnojamieji namų apyvokos daiktai.
            </li>
          </ul>
        </li>
        <li>
          3.3. Draudimo sąlygas, nenustatytas šiose Gyventojų turto draudimo
          specialiose sąlygose, reglamentuoja Taisyklės.
        </li>
        <li>3.4. Draudimo apsauga galioja sertifikate nurodytu adresu.</li>
        <li>
          3.5. Draudimo paslaugų variantai:
          <ul className="ml-2 list-none">
            <li>
              3.5.1. I variantas. Nekilnojamo turto (pastato (nuolat gyvenamo:
              namo, kotedžo, sodo namo arba buto)) draudimas:
              <ul className="ml-2 list-none">
                <li>3.5.1.1. Draudimo būdas – Primos rizikos</li>
                <li>
                  3.5.1.2. Draudžiamieji įvykiai: Ugnis, Vanduo, Gamtinės jėgos,
                  vagystė, vanduo, trečiųjų asmenų veika (Pagal{" "}
                  <a
                    href="https://www.gjensidige.lt/-/media/lt/valid-rules/2018/gt-papildomos/060-gyventoju-turto-draudimo-taisykles_lt_2018-04.pdf"
                    target="_blank"
                  >
                    gyventojų turto draudimo taisykles Nr. 060 punktus 43, 44,
                    45, 47, 54, 55
                  </a>
                  )
                </li>
                <li>3.5.1.3. Draudimo suma; 30 000 EUR.</li>
              </ul>
            </li>
            <li>
              3.5.2. II variantas. Namų turto (daiktų, esančių pastato (nuolat
              gyvenamo: namo, kotedžo, sodo namo arba buto) viduje)) draudimas:
              <ul className="ml-2 list-none">
                <li>3.5.2.1. Draudimo būdas – „Pirmos rizikos“</li>
                <li>
                  3.5.2.2. Draudžiamieji įvykiai: Ugnis; Gamtinės jėgos;
                  Vagystė; Vanduo, dužimas ir skilimas, Trečiųjų asmenų veika;
                  Draudžiamųjų įvykių pasekmėje atsiradę nuostoliai; Elektros
                  prietaisų gedimai dėl elektros įtampos svyravimų; Būsto nuomos
                  išlaidos; Papildomos išlaidos draudimo vietai po draudžiamojo
                  įvykio sutvarkyti (pagal{" "}
                  <a
                    href="https://www.gjensidige.lt/-/media/lt/valid-rules/2018/gt-papildomos/060-gyventoju-turto-draudimo-taisykles_lt_2018-04.pdf"
                    target="_blank"
                  >
                    Gyventojų turto draudimo taisykles Nr. 060
                  </a>{" "}
                  punktus 43, 44, 45, 47, 54, 55, 58, 62, 61, 63). Papildomai
                  apdraudžiama „Namų turto plėšimas už draudimo vietos ribų,
                  esant ne patalpoje“ (
                  <a
                    href="https://www.gjensidige.lt/-/media/lt/valid-rules/2018/gt-papildomos/060-gyventoju-turto-draudimo-taisykles_lt_2018-04.pdf"
                    target="_blank"
                  >
                    Gyventojų turto draudimo taisyklių Nr. 060
                  </a>{" "}
                  punktas 50) – iki 600 EUR vienam įvykiui ir per visą draudimo
                  sutarties galiojimo terminą
                </li>
                <li>3.5.2.3. Išskaita: Besąlyginė 60 EUR.</li>
                <li>3.5.2.4. Draudimo suma: 15 000 EUR;</li>
              </ul>
            </li>
            <li>
              3.5.3. III variantas. Pastato (nuolat gyvenamo: namo, kotedžo,
              sodo namo arba buto) savininko civilinės atsakomybės draudimas:
              <ul className="ml-2 list-none">
                <li>
                  3.5.3.1. Draudžiamieji įvykiai: pagal{" "}
                  <a
                    href="https://www.gjensidige.lt/-/media/lt/valid-rules/2018/gt-papildomos/060-gyventoju-turto-draudimo-taisykles_lt_2018-04.pdf"
                    target="_blank"
                  >
                    Gyventojų turto draudimo taisykles Nr. 060
                  </a>{" "}
                  punktus 77
                </li>
                <li>3.5.3.2. Draudimo suma 3000 EUR;</li>
                <li>3.5.3.3. Išskaita: Besąlyginė 60 EUR;</li>
              </ul>
            </li>
          </ul>
        </li>
        <li>
          Draudimo vieta – draudimo sertifikate nurodytas adresas Lietuvoje, o
          namų turtui už draudimo vietos ribų draudimo apsauga galioja
          geografinėje Europoje, išskyrus Rusiją, Ukrainą, Baltarusiją.
        </li>
      </ul>
      <h4>4. Nedraudžiami objektai ir nedraužiamieji įvykiai</h4>
      <ul className="ml-2 list-none">
        <span>Nedraudžiami objektai:</span>
        <li>4.1. Vertybių;</li>
        <li>
          4.2. Dviračių, kūdikių ir neįgaliųjų vežimėlių už draudimo vietos
          ribų;
        </li>
        <li>
          4.3. Namų turto už draudimo vietos ribų (lauke, patalpoje,
          automobilyje);
        </li>
        <li>
          4.4. Pastatų, butų LR įstatymų nustatyta tvarka pripažintų avariniais
          ar skirtų nugriovimui ir juose esančio namų turto
        </li>
        <li>
          4.5. Pastatų, butų, kurie pastatyti ar perstatyti savavališkai be
          tinkamai suderinto projekto bei statybos leidimo, jei tokių reikia
          pagal LR įstatymus;
        </li>
        <li>
          4.6. Bendro naudojimo patalpų, daugiabučių namų rūsių, požeminių
          stovėjimo aikštelių, inžinerinių statinių, inžinerinių tinklų, bet
          kokios įrangos ir įrengimų, skirtų ne vien tik apdraudžiamo pastato,
          buto eksploatacijai ir/ar aptarnavimui, jeigu tai nėra numatyta
          draudimo sutartyje. Ši išimtis netaikoma dvibučiams pastatams ir
          kotedžams;
        </li>
        <li>
          4.7. Namų turto, esančio bendro naudojimo patalpose (pvz. laiptinių
          aikštelėse, koridoriuose ir pan.), atviruose balkonuose (lodžijose);
        </li>
        <li>
          4.8. Pastatų, butų, kuriuose vykdoma komercinė, individuali veikla,
          įrangos ir įrengimų naudojamų išimtinai verslui;
        </li>
        <li>4.9. Turto, naudojamo Jūsų profesinėje veikloje;</li>
        <li>4.10. Bet kokių komercinių ar pardavimui skirtų prekių;</li>
        <li>
          4.11. Šiltnamių, kurie neturi stacionarių pamatų ir/arba jų karkasai
          yra pagaminti iš plastiko ar medžio arba kurie yra dengti polietileno
          plėvele;
        </li>
        <li>
          4.12. Radijo bei TV antenų ir jų įrangos skirtos bendram naudojimui;
        </li>
        <li>4.13. Reklaminių ženklų ir jų iškabų;</li>
        <li>
          4.14. Grunto, žemės, žemės sklypų, pylimų, dambų, vandens telkinių;
        </li>
        <li>4.15. Augalų (flora), paukščių, gyvūnų (fauna);</li>
        <li>4.16. Pašarų gyvuliams, žemės ūkio produkcijos atsargų</li>
        <li>
          4.17. Visų rūšių sausumos motorinių ir elektrinių transporto priemonių
          (įskaitant motorolerius, keturračius, priekabas), kurios teisės aktų
          numatyta tvarka registruojamos atitinkamose institucijose (pvz., VĮ
          Regitra, savivaldybės administracijos žemės ūkio skyriuje ir pan.), jų
          sudėtinių, atsarginių dalių, detalių, išskyrus išvardintas šių
          taisyklių 37.2 punkte. Ši sąlyga taip pat netaikoma lengvųjų
          automobilių papildomai įrangai kaip numatyta taisyklių 37.1 punkto f)
          papunktyje;
        </li>
        <li>
          4.18. Vandens transporto priemonių (pvz. jachtų, laivų ir pan.),
          išskyrus išvardintas šių taisyklių 37.2 punkte, oro, geležinkelio
          transporto priemonių (pvz. skraidyklių, dronų, lėktuvų, traukinių,
          riedžių ir pan.), jų sudėtinių, atsarginių dalių, detalių;
        </li>
        <li>
          4.19. Bet kokio kuro (pvz. benzino, dyzelino, žibalo ir pan.),
          išskyrus kurą naudojamą pastato šildymui;
        </li>
        <li>
          4.20. Programinės įrangos (išskyrus programinę įrangą, kuri yra
          įdiegta perkant kompiuterį), informacijos ir duomenų esančių bet
          kokios rūšies duomenų laikmenose;
        </li>
        <li>4.21. Neregistruotų šaunamųjų ginklų;</li>
        <li>
          4.22. Alkoholinių gėrimų, narkotinių medžiagų, vaistų, maisto
          produktų, tabako gaminių;
        </li>
        <li>
          4.23. Radioaktyvių medžiagų, branduolinio kuro, sprogstamųjų medžiagų;
        </li>
        <li>
          4.24. Vertybių nenuolatinėje gyvenamojoje vietoje, sandėliukuose,
          pagalbiniuose pastatuose ir garažuose;
        </li>
        <li>
          Namų turto (daiktų) nebaigtos statybos pastatuose, butuose, išskyrus
          pastatus, butus, kuriuose visi statybos darbai (įskaitant apdailos
          darbus) yra pabaigti, tik pilnas baigtumas neįregistruotas
          nekilnojamojo turto registre (dokumentaliai);
        </li>
        <li>
          4.26. Draudėjo svečių daiktų, esančių apdraustame pastate, bute;
        </li>
        <li>
          4.27. Statybinių medžiagų, t.y. pastato, buto elementų, kurie nebuvo
          sumontuoti draudžiamojo įvykio momentu (pvz. nesumontuota santechnika,
          neišklijuotos grindų plytelės ir pan.)
        </li>
        <span>Nedraudžiamieji įvykiai:</span>
        <li>
          4.28. Visi įvykiai, kurie pagal{" "}
          <a
            href="https://www.gjensidige.lt/-/media/lt/valid-rules/2018/gt-papildomos/060-gyventoju-turto-draudimo-taisykles_lt_2018-04.pdf"
            target="_blank"
          >
            Gyventojų turto draudimo taisykles Nr. 060
          </a>{" "}
          yra nurodyti kaip Bendri nedraudžiamieji įvykiai, arba nurodyti kaip
          nedraudžiamieji įvykiai prie kiekvienos draudžiamos rizikos (įvykio)
          atskirai.
        </li>
      </ul>
      <h4>5. Informacijos kitai sutarties šaliai teikimo tvarka</h4>
      <ul className="ml-2 list-none">
        <li>
          5.1. Bet koks pranešimas, kurį Draudikas, Draudėjas ar Apdraustasis
          privalo perduoti vienas kitam, turi būti pateikimas raštu. Tarpininkai
          nėra įgalioti šiuos pranešimus priimti
        </li>
        <li>
          5.2. Pranešimai Draudikui, Draudėjui ar Apdraustajam siunčiami raštu
          faksimiliniu ryšiu arba paštu arba naudojantis kurjerio paslaugomis.
          Pranešimas, išsiųstas elektroniniu laišku elektroninio pašto adresu,
          nurodytu sertifikate, arba laišku adresu, nurodytu sertifikate, , arba
          įteiktas kitai sutarties šaliai adresu, nurodytu sertifikate,
          naudojantis kurjerio paslaugomis, laikomas įteiktas tinkamai pagal
          šias Taisykles, išskyrus šiose Taisyklėse numatytus atvejus.
          Draudikas, Draudėjas ir Apdraustasis privalo informuoti vienas kitą
          apie adreso pasikeitimą.
        </li>
        <li>
          5.3. Laikoma, kad pranešimo tinkamo įteikimo diena yra:
          <ul className="ml-2 list-none">
            <li>
              5.3.1. kai siunčiama elektroniniu paštu, faksimiliniu ryšiu – kita
              darbo diena po pranešimo išsiuntimo dienos;
            </li>
            <li>
              5.3.2. kai siunčiama paštu:
              <ul className="ml-2 list-none">
                <li>
                  5.3.2.1. paštu paprastu laišku – pranešimas laikomas įteiktas
                  tinkamai praėjus protingam terminui po jo išsiuntimo;
                </li>
                <li>
                  5.3.2.2. paštu registruotu laišku – pranešimo gavimo diena
                  (pranešimo gavimo diena nustatoma pagal oficialų pašto spaudą,
                  uždėtą pašto įstaigos, turinčios tam teisę).
                </li>
                <li>
                  5.3.2.3. kai siunčiama per kurjerį – diena, kurią draudėjui
                  yra įteikiamas pranešimas.
                </li>
              </ul>
            </li>
          </ul>
        </li>
      </ul>
      <h4>6. Pranešimų apie įvykį pateikimo tvarka</h4>
      <ul className="ml-2 list-none">
        <li>
          6.1. Draudimo sutarties galiojimo metu atsitikus draudžiamajam
          įvykiui, Apdraustasis privalo:
          <ul className="ml-2 list-none">
            <li>
              6.1.1. Ne vėliau kaip per 3 kalendorines dienas pranešti apie
              įvykį vienu iš šių būdų:
              <ul className="ml-2 list-none">
                <li>
                  6.1.1.1. Internetu{" "}
                  <a
                    href="https://www.gjensidige.lt/atsitikus-ivykiui/registruokite-ivyki-internetu"
                    target="_blank"
                  >
                    https://www.gjensidige.lt/atsitikus-ivykiui/registruokite-ivyki-internetu
                  </a>
                </li>
                <li>6.1.1.2. Raštu;</li>
                <li>6.1.1.3. Telefonu 1626 (iš užsienio +370 5 2721626);</li>
              </ul>
            </li>
          </ul>
        </li>
        <li>
          6.2. Užpildyti Draudiko nustatytos formos prašymą draudimo išmokai
          gauti ir kartu su juo Draudikui pateikti:
          <ul className="ml-2 list-none">
            <li>6.2.1. asmens tapatybę patvirtinantį dokumentą;</li>
            <li>6.2.2. būsto nuosavybės teisę patvirtinanti dokumentą;</li>
          </ul>
        </li>
        <li>
          6.3. Šių specialiųjų sąlygų 6.2. punkte išvardintus dokumentus
          Apdraustais Draudikui gali pateikti vienu iš šių būdų:
          <ul className="ml-2 list-none">
            <li>
              6.3.1. internetu{" "}
              <a href="https://www.gjensidige.lt" target="_blank">
                www.gjensidige.lt
              </a>
              ;
            </li>
            <li>
              6.3.2. pristatyti į artimiausią Draudiko Žalų centrą (Draudiko
              Žalų centrų adresai yra skelbiami{" "}
              <a href="https://www.gjensidige.lt" target="_blank">
                www.gjensidige.lt
              </a>
              );
            </li>
            <li>
              6.3.3. jei Jūsų mieste nėra Draudiko Žalų centro – pristatyti ar
              atsiųsti į artimiausią Draudiko skyrių (Draudiko skyrių adresai
              yra skelbiami{" "}
              <a href="https://www.gjensidige.lt" target="_blank">
                www.gjensidige.lt
              </a>
              ).
            </li>
          </ul>
        </li>
      </ul>
      <h4>7. Draudimo išmokos mokėjimo tvarka</h4>
      <ul className="ml-2 list-none">
        <li>
          7.1. Draudimo išmoka yra išmokama ne vėliau kaip per 30 kalendorinių
          dienų nuo tos dienos, kai Draudikas gavo visą informaciją, reikšmingą
          draudžiamojo įvykio faktui, aplinkybėms ir pasekmėms bei draudimo
          išmokos dydžiui nustatyti.
        </li>
        <li>
          7.2. Draudikas turi teisę atidėti išmokėjimą:
          <ul className="ml-2 list-none">
            <li>
              7.2.1. Jei Apdraustajam dėl įvykio, kuris gali būti pripažintas
              draudžiamuoju, reiškiamas civilinis ieškinys ar keliama
              baudžiamoji byla, ar pradėtas teismo procesas – iki teismo
              sprendimo įsiteisėjimo ar nutraukimo dienos;
            </li>
            <li>
              7.2.2. Kol Apdraustasis pateiks draudžiamąjį įvykį pagrindžiančius
              dokumentus
            </li>
            <li>
              7.2.3. Kol Apdraustasis (naudos gavėjas) pagrįs nuostolio dydį,
              tuo atveju, kai Draudiko nustatytas nuostolio dydis Apdraustojo
              netenkina.;
            </li>
            <li>
              7.2.4. Kitais draudimo sutartyje ir įstatymų numatytais atvejais.
            </li>
          </ul>
        </li>
      </ul>
    </div>
  );
};
